import React from 'react';
import { useStyletron } from 'baseui';
import { Link } from 'react-router-dom';
import { Avatar } from 'baseui/avatar';
import logo from '../images/logo.png';

const Header = ({
    user, onShowLogin, onLogout,
}) => {
    const [css] = useStyletron();
    const cardRootStyle = {};
    cardRootStyle.color = '#FFFFFF';
    cardRootStyle.backgroundColor = '#0077c8';
    cardRootStyle.borderBottomColor = '#000000';
    cardRootStyle.borderBottomWidth = '1px';
    cardRootStyle.borderBottomStyle = 'solid';
    cardRootStyle.paddingTop = '10px;';
    cardRootStyle.paddingLeft = '10px;';
    cardRootStyle.paddingBottom = '5px;';
    cardRootStyle.paddingRight = '10px;';

    return (
        <div className={css(cardRootStyle)}>

            <div className={css({
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: 0,
                zIndex: '1000',
            })}
            >
                <Link to="/" className={css({ flex: '1', maxWidth: '378px' })}><img className={css({ maxWidth: '100%' })} src={logo} alt="Rochester Regional Hospital" /></Link>
                <div className={css({
                    flex: '2',
                    textAlign: 'center',
                    fontSize: '16px',
                    paddingTop: '5px;',
                    '@media screen and (min-width: 564px)': { fontSize: '26px', paddingTop: '5px;' },
                    '@media screen and (min-width: 764px)': { fontSize: '36px' },
                    '@media screen and (min-width: 960px)': { fontSize: '46px' },
                })}
                >Mask Pickup Tracker
                </div>
                { user && (
                    <div className={css({
                        flex: 1, maxWidth: '200px', display: 'flex', justifyContent: 'flex-end',
                    })}
                    >
                        <div className={css({
                            position: 'relative',
                            top: '1px',
                            marginRight: '10px',
                            display: 'flex',
                            flexDirection: 'column',
                        })}
                        >
                            <div className={css({ fontSize: '14px', whiteSpace: 'nowrap' })}>{user.handle}</div>
                            <div className={css({ textAlign: 'center' })}>
                                <button
                                    className={css({
                                        cursor: 'pointer', backgroundColor: '#000000', color: '#ffffff', border: 'none', borderRadius: '5px', fontSize: '12px',
                                    })}
                                    onClick={onLogout}
                                >Logout
                                </button>
                            </div>
                        </div>

                        { user.photoURL && <Avatar
                            name={user ? user.handle : ''}
                            size="scale1200"
                            src={user.photoURL}
                        /> }
                    </div>)}

                { !user && (
                    <div className={css({ flex: 1, maxWidth: '200px' })}>
                        <button
                            className={css({
                                cursor: 'pointer', backgroundColor: '#000000', color: '#FFFFFF', border: 'none', borderRadius: '5px', fontSize: '12px',
                            })}
                            onClick={onShowLogin}
                        >Login
                        </button>
                    </div>
                )}
            </div>

            { (user && user.authorized) && (
                <div className={css({
                    marginTop: '5px', display: 'flex', backgroundColor: '#525252', marginBottom: '-5px', marginLeft: '-10px', marginRight: '-10px', justifyContent: 'space-between', padding: '3px',
                })}
                >
                    <Link
                        to="/"
                        className={css({
                            flex: '1',
                            textAlign: 'center',
                            color: '#FFFFFF',
                            textDecoration: 'none',
                            fontSize: '12px',
                            ':hover': { color: '#0077c8' },
                            '@media screen and (min-width: 564px)': { fontSize: '18px' },
                            '@media screen and (min-width: 764px)': { fontSize: '20px' },
                            '@media screen and (min-width: 960px)': { fontSize: '22px' },
                        })}
                    >Pickup Validator
                    </Link>
                    <Link
                        to="/settings"
                        className={css({
                            flex: '1',
                            textAlign: 'center',
                            color: '#FFFFFF',
                            textDecoration: 'none',
                            fontSize: '12px',
                            ':hover': { color: '#0077c8' },
                            '@media screen and (min-width: 564px)': { fontSize: '18px' },
                            '@media screen and (min-width: 764px)': { fontSize: '20px' },
                            '@media screen and (min-width: 960px)': { fontSize: '22px' },
                        })}
                    >Period Settings
                    </Link>
                    <Link
                        to="/leaders"
                        className={css({
                            flex: '1',
                            textAlign: 'center',
                            color: '#FFFFFF',
                            textDecoration: 'none',
                            fontSize: '12px',
                            ':hover': { color: '#0077c8' },
                            '@media screen and (min-width: 564px)': { fontSize: '18px' },
                            '@media screen and (min-width: 764px)': { fontSize: '20px' },
                            '@media screen and (min-width: 960px)': { fontSize: '22px' },
                        })}
                    >Approved Leaders
                    </Link>
                </div>
            )}
        </div>
    );
};


export default Header;
